<template>
  <div v-if="$apollo.loading">
    <spinner />
  </div>
  <div v-else class="page-container">
    <div class="header">
      <div class="header-left">
        <img src="/assets/color-logo.svg" alt="CoreEvent logo" class="coreEvent-logo">
        <span>CoreEvent d.o.o</span>
        <span>Dunjevac 15, 10000 Zagreb, HR</span>
      </div>
      <div class="header-right">
        <span>Mail: <a href="mailto:contact@core-event.co">contact@core-event.co</a></span>
        <span>OIB: 36611335369</span>
        <span>IBAN: HR5223400091111141277</span>
        <span>Privredna banka Zagreb d.d., Radnička cesta 50, Zagreb</span>
      </div>
    </div>
    <span id="page-title">Izjava o prijeboju (kompenzaciji) broj: {{ compensationId }} </span>
    <span class="event-title">{{ event.title }} / {{ eventDate }}</span>
    <div class="user-informations-container">
      <div class="user-info-container">
        <div class="user-title">VJEROVNIK</div>
        <div class="user-informations">
          <p>
            <b>{{ organization.legalName }}</b>
          </p>
          <div style="display: flex; flex-direction: column">
            <span>
              <b>OIB: {{ organization.OIB }}</b>
            </span>
            <span>IBAN: {{ organization.IBAN }}</span>
            <span>
              Adresa: {{ organization.address }}, {{ organization.postalCode }}
              {{ organization.city }}
            </span>
          </div>
        </div>
      </div>
      <div class="user-info-container">
        <div class="user-title">DUŽNIK</div>
        <div class="user-informations">
          <p><b>CoreEvent d.o.o.</b></p>
          <div style="display: flex; flex-direction: column">
            <span><b>OIB: 36611335369</b></span>
            <span>IBAN: HR5223400091111141277</span>
            <span>Adresa: Dunjevac 15, 10000 Zagreb, HR</span>
          </div>
        </div>
      </div>
    </div>
    <div style="text-align: center">
      Dajemo izjavu da obavljamo prijeboj (kompenzaciju) slijedećih medusovnih novčanih
      potraživanja:
    </div>
    <div class="user-informations-container">
      <div class="user-info-container">
        <div class="user-informations">
          <p style="font-size: 13px"><b>VJEROVNIKOVE DOSPJELE OBVEZE PREMA DUŽNIKU</b></p>
          <div style="display: flex; justify-content: space-around">
            <div style="text-align: center">
              <div>Račun broj</div>
              <div>1</div>
              <div>{{ invoiceId }}</div>
            </div>
            <div style="text-align: center">
              <div>Datum računa</div>
              <div>2</div>
              <div>{{ dateNow }}</div>
            </div>
            <div style="text-align: center">
              <div>Iznos</div>
              <div>3</div>
              <div>
                {{ totalCoreEventFeeWithVAT }}
              </div>
            </div>
          </div>
          <p style="margin-top: 16px; text-align: right; border-top: 2px solid black">
            Ukupno:
            {{ totalCoreEventFeeWithVAT }} EUR
          </p>
        </div>
      </div>
      <div class="user-info-container">
        <div class="user-informations">
          <p style="font-size: 13px"><b>DUŽNIKOVE DOSPJELE OBVEZE PREMA VJEROVNIKU</b></p>
          <div style="display: flex; justify-content: space-around">
            <div style="text-align: center">
              <div>Račun broj</div>
              <div>4</div>
              <div>{{ invoiceId }}</div>
            </div>
            <div style="text-align: center">
              <div>Datum računa</div>
              <div>5</div>
              <div>{{ dateNow }}</div>
            </div>
            <div style="text-align: center">
              <div>Iznos</div>
              <div>6</div>
              <div>{{ totalSoldAmount }}</div>
            </div>
          </div>
          <p style="margin-top: 16px; text-align: right; border-top: 2px solid black">
            Ukupno: {{ totalSoldAmount }} EUR
          </p>
        </div>
      </div>
    </div>
    <p class="total">
      Razlika (stupac 6 manje stupac 3):
      {{ differenceAmount }} EUR
    </p>
    <div style="display: flex; align-items: center; justify-content: space-around">
      <div>U Zagrebu, {{ dateNow }}</div>
      <div>Izdao: Filip Gobin</div>
    </div>
    <div style="margin-top: 8px">
      <p style="color: red; text-align: center">NAPOMENA: Kompenzaciju nije potrebno ovjeriti.</p>
      <p style="text-align: center; margin: 0 24px">
        Ovaj dokument je generiran elektroničkim putem iz CoreEvent sustava te je kao takav važeći
        bez pečata i potpisa društva CoreEvent d.o.o. kao izdavatelja dokumenta.
      </p>
    </div>
    <hr>
    <div>
      <div style="text-align: center; font-size: 12px">
        CoreEvent d.o.o. za usluge, turistička agencija, upis u Trgovački sud u Zagrebu pod MBS:
        081377997
      </div>
      <div style="text-align: center; font-size: 12px">
        Temeljni kapital: 20.000,00 kuna / 2.654,46 euro (fiksni tečaj konverzije 7.53450) uplaćen u
        cijelosti, direktor: Filip Gobin
      </div>
      <div style="text-align: center; font-size: 12px">
        Račun za redovno poslovanje društva vodi se kod Privredne banke Zagreb d.d., Radnička cesta
        50, Zagreb
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { round } from 'lodash'
import { GET_PURCHASE_SUMMARY } from '@/graphql/purchase.graphql'
import { getEventVAT } from '@/utils'

export default {
  props: {
    eventId: String,
    invoiceId: String,
  },
  data() {
    return {
      event: {},
      organization: null,
      serviceFee: null,
      compensationId: null,
      dateNow: moment().format('DD.MM.YYYY'),
      totalSoldAmount: '',
      totalCoreEventFee: '',
      refundedOrders: null,
      totalCoreEventFeeWithVAT: '',
      differenceAmount: '',
      kickbackTotal: 0,
    }
  },
  computed: {
    // Compute the event date formatted
    eventDate() {
      return moment(this.event.from).format('DD.MM.YYYY')
    },
  },
  apollo: {
    getPurchasesByEvent: {
      query: GET_PURCHASE_SUMMARY,
      variables() {
        return {
          eventId: this.eventId,
        }
      },
      result({ data, loading }) {
        if (loading || !data.getPurchaseSummary) {
          return
        }
        const summary = data.getPurchaseSummary

        // Assign data directly from the backend
        this.event = summary.event
        this.organization = summary.event.organization
        this.compensationId = `K-${this.invoiceId}`
        this.totalSoldAmount = round(summary.totalSoldAmount - summary.refundInfo.amount, 2)
        this.totalCoreEventFee = summary.totalCoreEventFee
        this.kickbackTotal = round((Number(summary.totalSoldCount) || 0) * (Number(this.organization.kickbackPerTicket) || 0), 2)
        this.refundedOrders = {
          ...summary.refundInfo,
          amountWithoutVat: round(
            summary.refundInfo.amount / (1 + getEventVAT(summary.event) / 100),
            2,
          ),
        }
        const refunded = { online: 0, amountOnline: 0, offline: 0, amountOffline: 0 }
        summary.purchaseInfo.map(info => {
          if (info.status !== 'SUCCESSFUL') {
            refunded.amountOffline += Number(info.offline)
            refunded.amountOnline += Number(info.online)
            refunded[Number(info.offline) ? 'offline' : 'online'] += Number(info.total)
          }
        })
        const removeRefundedOrderCoreEventFeeOffline =
          refunded.offline * ((Number(this.organization.serviceFee) + 3 || 0) / 100)

        const removeRefundedOrderCoreEventFeeOnline =
          refunded.online * ((Number(this.organization.serviceFee) || 0) / 100)

        this.totalCoreEventFeeWithVAT = round(
          summary.totalCoreEventFeeWithVAT -
            removeRefundedOrderCoreEventFeeOnline * 1.25 -
            removeRefundedOrderCoreEventFeeOffline * 1.25 -
            this.kickbackTotal * 1.25,
          2,
        )

        this.differenceAmount = round(this.totalSoldAmount - this.totalCoreEventFeeWithVAT, 2)
      },
    },
  },
}
</script>

<style scoped>
#page-title {
  font-weight: 500;
  font-size: 32px;
  text-align: center;
}

.page-container {
  display: flex;
  flex-direction: column;
  width: 210mm;
  padding: 1.5rem;
  row-gap: 1rem !important;
}

.header {
  display: flex;
  justify-content: space-between;
  padding-bottom: 0.5rem;
  border-bottom: 2px solid black;
}

.coreEvent-logo {
  width: 5.625rem;
  margin-bottom: 0.625rem;
}

.header-right {
  display: flex;
  flex-direction: column;
}

.header-left {
  display: flex;
  flex-direction: column;
}

.user-informations {
  border: 2px solid black;
  padding: 16px 16px 24px;
}

.user-informations-container {
  display: flex;
  justify-content: space-around;
}

.user-title {
  text-align: center;
}

.user-info-container {
  width: 48%;
}

.event-title {
  text-align: center;
  font-weight: 500;
  font-size: 18px;
  height: 30px;
  margin-bottom: 12px;
}

.total {
  text-align: center;
  font-size: 18px;
  border-bottom: 2px solid black;
  width: 85%;
  margin: 0 auto;
}
</style>
